import { createApi } from '@reduxjs/toolkit/query/react';
import { GetFiltersByEnumResponse } from 'lib.store/src/main/enums/models';
import {
  GetStrategyByIdResponse,
  GetStrategyMessagesResponse,
  PostStrategyConversationResponse,
} from './models';
import { baseQueryWithReauth } from '../main/baseQueryWithReauth';
const ai_assistence = `ai_assistence`;

export const aiAssistence = createApi({
  reducerPath: ai_assistence,
  baseQuery: baseQueryWithReauth,
  tagTypes: [ai_assistence],
  endpoints: (build) => ({
    getStrategyByEventId: build.query<GetStrategyByIdResponse, { eventId: string }>({
      query: ({ eventId }) => ({
        url: `/partner/events/${eventId}/strategy`,
        headers: {
          Accept: 'application/json',
        },
      }),
      providesTags: [ai_assistence],
    }),
    getStrategyMessages: build.query<GetStrategyMessagesResponse, { eventId: string }>({
      query: ({ eventId }) => ({
        url: `/partner/events/${eventId}/strategy/messages`,
        headers: {
          Accept: 'application/json',
        },
      }),
      providesTags: [ai_assistence],
    }),

    postGenerateStrategyPlan: build.mutation<any, { eventId: string }>({
      query: ({ eventId }) => ({
        url: `/partner/events/${eventId}/strategy/generate`,
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      }),
      // invalidatesTags: [ai_assistence],
    }),

    postStrategyConversation: build.mutation<
      PostStrategyConversationResponse,
      { eventId: string; message: string }
    >({
      query: ({ eventId, message }) => ({
        url: `/partner/events/${eventId}/strategy/conversation`,
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
        body: {
          message,
        },
      }),
      // invalidatesTags: [ai_assistence],
    }),

    getChannelsToListen: build.query<GetFiltersByEnumResponse, undefined>({
      query: () => {
        return {
          url: '/enums/broadcast_event/filter',
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
    }),
    getEvenstToListen: build.query<GetFiltersByEnumResponse, undefined>({
      query: () => {
        return {
          url: '/enums/broadcast_event/filter',
          headers: {
            Accept: 'application/json', // Specify JSON response
          },
        };
      },
    }),
  }),
});

export const {
  useGetStrategyByEventIdQuery,
  useGetStrategyMessagesQuery,
  usePostGenerateStrategyPlanMutation,
  usePostStrategyConversationMutation,

  useLazyGetStrategyMessagesQuery,
  useLazyGetChannelsToListenQuery,
  useLazyGetEvenstToListenQuery,
} = aiAssistence;
